/* eslint-disable import/prefer-default-export */
import axiosApiInstance from '@webclient/lib/agent/services/api/axiosInstance';

import { PaginationType } from '@webclient/shared-types/pagination';

type GetNotificationsProps = PaginationType & {
  order?: 'ASC' | 'DESC';
};

export type ProcessNotificationProps = {
  notificationId: number;
  action: string;
};

export type DismissNotificationProps = {
  notificationId: number;
};

export const notifications = {
  getNotifications: (
    { page = 1, limit = 10, order = 'DESC' }: GetNotificationsProps = {
      page: 1,
      limit: 10,
      order: 'DESC',
    },
  ) => {
    return axiosApiInstance.get('/v1/entities/notifications', {
      params: {
        page,
        limit,
        order,
      },
    });
  },

  processNotification: ({
    notificationId,
    action,
  }: ProcessNotificationProps) => {
    return axiosApiInstance.post(
      `/v1/actions/notifications/${notificationId}/process`,
      { action_id: action },
    );
  },

  dismissNotification: ({ notificationId }: DismissNotificationProps) => {
    return axiosApiInstance.patch(
      `/v1/actions/notifications/${notificationId}/dismiss`,
    );
  },
};
